import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import MainFont from 'ui/typography/mainFont';

// eslint-disable-next-line import/no-cycle
import { Textarea } from 'ui/atoms';
//import Toast from 'ui/components/Toast';
import { Error, FormTextAreaContainer, HeaderContainer, Label } from './style';

const FormTextArea = props => {
  const {
    label,
    type,
    valid,
    value,
    readonly,
    visible,
    isLeadDetail,
    isEditing,
    variant,
    maxLength,
    onFocus,
    onChange
  } = props;

  const { t } = useTranslation();
  const [internalValue, setInternalValue] = useState(value || '');

  return (
    <>
      {visible && (
        <FormTextAreaContainer
          className="form-inputs"
          type={type}
          readonly={readonly}
          isLeadDetail={isLeadDetail}
          onClick={onFocus}
        >
          <HeaderContainer>
            <Label type={type} isEditing={isEditing}>
              <MainFont configuration={{ fontSize: 12, lineHeight: '1.33' }}>
                {maxLength && isLeadDetail
                  ? `${(internalValue?.length || 0).toString()} /
                    ${maxLength.toString()} ${t('characters')} ${
                      (internalValue?.length ? internalValue.length : 0) ===
                      maxLength
                        ? t('invalid_note_length')
                        : ''
                    }`
                  : { label }}
              </MainFont>
            </Label>
          </HeaderContainer>
          <Textarea
            {...props}
            value={internalValue}
            placeholder={!internalValue ? '-' : null}
            variant={variant}
            onChange={event => {
              if (variant === 'leadDetail') {
                const strippedValue = event.currentTarget?.value?.substring(
                  0,
                  maxLength
                );
                setInternalValue(strippedValue);
                onChange(strippedValue);
              }
            }}
            status={internalValue?.length > maxLength ? 'invalid' : null}
            maxLength={maxLength}
            isOnLeadDetail={isLeadDetail}
          />
          {!readonly && (!valid || typeof valid === 'string') && value && (
            <Error>
              <MainFont type="error">{valid || 'Error'}</MainFont>
            </Error>
          )}
        </FormTextAreaContainer>
      )}
    </>
  );
};

FormTextArea.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  type: PropTypes.string,
  valid: PropTypes.bool,
  readonly: PropTypes.bool,
  precompiled: PropTypes.bool,
  visible: PropTypes.bool,
  labelFromBe: PropTypes.string,
  handleDeletePreference: PropTypes.func,
  variant: PropTypes.oneOf(['default', 'form', 'leadDetail']),
  maxLength: PropTypes.number,
  onChange: PropTypes.func,
  isLeadDetail: PropTypes.bool
};

FormTextArea.defaultProps = {
  readonly: false,
  valid: true,
  isNewValue: false
};

export default FormTextArea;
